import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import { theme } from './theme/theme';
import { Router } from './router';
import { ErrorFallback } from './app/components/ErrorFallback';
import { LogViewer } from './app/components/LogViewer';
import { DebugOverlay } from './app/components/DebugOverlay';
import { StatusIndicator } from './app/components/StatusIndicator';
import UpdateAvailableModal from './app/components/UpdateAvailableModal';
import InstallPromptProvider from './app/components/pwa-install/InstallPromptProvider';
import { useState, useEffect } from 'react';

function App() {
  console.log('🎯 [App] Componente App sendo renderizado');
  const [error, setError] = useState(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    console.log('%c[App] ====== COMPONENTE APP MONTADO ======', 'background: #0066cc; color: white; font-size: 14px; padding: 4px;');
    
    // Marcar script como carregado após um pequeno delay para garantir que tudo foi inicializado
    const timer = setTimeout(() => {
      setScriptLoaded(true);
    }, 100);
    
    // Capturar erros não tratados
    const handleError = (event) => {
      console.error('%c[App] ERRO NÃO TRATADO:', 'background: red; color: white; font-size: 14px; padding: 4px;', event.error);
      console.error('[App] Stack:', event.error?.stack);
      setError(event.error);
    };

    const handleRejection = (event) => {
      console.error('%c[App] PROMISE REJEITADA:', 'background: orange; color: white; font-size: 14px; padding: 4px;', event.reason);
      console.error('[App] Stack:', event.reason?.stack);
      setError(event.reason);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    console.log('[App] Aplicação iniciada');
    console.log('[App] BrowserRouter será renderizado');

    return () => {
      clearTimeout(timer);
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, []);

  if (error) {
    return <ErrorFallback error={error} resetError={() => setError(null)} />;
  }

  // Mostrar apenas spinner enquanto script está carregando
  if (!scriptLoaded) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
          }}
        >
          <CircularProgress size={48} sx={{ color: 'primary.main' }} />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <InstallPromptProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {import.meta.env.DEV && <StatusIndicator />}
        <BrowserRouter>
          <Router />
          {import.meta.env.DEV && <LogViewer />}
        </BrowserRouter>
        {import.meta.env.DEV && <DebugOverlay />}
        <UpdateAvailableModal />
      </ThemeProvider>
    </InstallPromptProvider>
  );
}

export default App;

